import React, { memo } from 'react';
import { ArrowRight, Zap, Clock, Shield } from 'lucide-react';
import './Hero.css';

const Hero = memo(() => {
  return (
    <section className="hero" id="hero">
      <div className="hero__bg">
        <div className="hero__gradient-orb hero__gradient-orb--1" />
        <div className="hero__gradient-orb hero__gradient-orb--2" />
        <div className="hero__grid-pattern" />
      </div>

      <div className="hero__container container">
        <div className="hero__content hero__content--animate">
          <div className="hero__badge">
            <Zap size={14} />
            <span>Websites delivered in as little as 5 days</span>
          </div>

          <h1 className="hero__title">
            <span className="hero__title-line">Your business deserves</span>
            <br />
            <span className="hero__title-accent">a stunning website.</span>
          </h1>

          <p className="hero__subtitle">
            We build professional, mobile-friendly websites for small and medium
            businesses. From brand identity to a full online presence — get everything
            you need to win more customers.
          </p>

          <div className="hero__actions">
            <a href="#packages" className="btn-primary hero__cta">
              See Packages & Pricing
              <ArrowRight size={18} />
            </a>
            <a href="#quiz" className="btn-secondary hero__cta-quiz">
              Help Me Choose
            </a>
            <a href="#process" className="btn-secondary">
              How It Works
            </a>
          </div>

          <div className="hero__stats">
            <div className="hero__stat">
              <Clock size={18} className="hero__stat-icon" />
              <span><strong>5–21 day</strong> delivery</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <Shield size={18} className="hero__stat-icon" />
              <span><strong>50% upfront</strong>, 50% on delivery</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hero__scroll">
        <div className="hero__scroll-dot" />
      </div>
    </section>
  );
});

export default Hero;
